import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

// ─── Service ──────────────────────────────────────────────────────────────────

@Injectable({ providedIn: 'root' })
export class CollabrationRequestService {

    private http = inject(HttpClient);
    private platformId = inject(PLATFORM_ID);

    private refreshEvents$ = new Subject<void>();
    onRefreshEvents$ = this.refreshEvents$.asObservable();

    postCollabrationAccept(postId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.patch<any>(`${environment.apiUrl}/posts/${postId}/collaborate/accept`, {});
    }

    postCollabrationDecline(postId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.patch<any>(`${environment.apiUrl}/posts/${postId}/collaborate/decline`, {});
    }

    eventCollabrationAccept(eventId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.patch<any>(`${environment.apiUrl}/events/${eventId}/collaborate/accept`, {});
    }

    eventCollabrationDecline(eventId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.patch<any>(`${environment.apiUrl}/events/${eventId}/collaborate/decline`, {});
    }

    blogCollabrationAccept(blogId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.patch<any>(`${environment.apiUrl}/blogs/${blogId}/collaborate/accept`, {});
    }

    blogCollabrationDecline(blogId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.patch<any>(`${environment.apiUrl}/blogs/${blogId}/collaborate/decline`, {});
    }
}